import { createCRUDHook } from './createCRUDHook';
import {
  DraftPartDto,
  DraftPartListByStaffDto,
} from 'utils/models';
import {
  CREATE_PART_BY_DRAFT_PART,
  GET_DRAFT_PART_DETAIL_BY_STAFF_ID,
  TBL_DRAFT_PART,
} from './apiEndPoints';

interface DraftPartCustomOperations {
  getDraftPartsDataByStaffId: (
    staffId: number
  ) => Promise<DraftPartListByStaffDto>;

  createPartByDraftPart: (draftPartId: number) => Promise<number>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  DraftPartDto,
  DraftPartDto[],
  DraftPartCustomOperations
>({
  entityName: 'DraftPart',
  endpoint: TBL_DRAFT_PART,

  customOperations: (auth) => ({
    getDraftPartsDataByStaffId: async (
      staffId: number
    ): Promise<DraftPartListByStaffDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_DRAFT_PART +
            GET_DRAFT_PART_DETAIL_BY_STAFF_ID +
            `?staffId=${staffId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    createPartByDraftPart: async (draftPartId: number): Promise<number> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_DRAFT_PART +
            CREATE_PART_BY_DRAFT_PART +
            `?draftPartId=${draftPartId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const DraftPartContext = Context;
export const useDraftPartManager = useManager;
export const useDraftPart = useConsumer;
